
import { portfolioProjects } from '../../../mocks/portfolio';

export default function Portfolio() {
  return (
    <section id="portfolio" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4">
            <span className="text-gray-900">Recent </span>
            <span className="text-teal-600">Transformations</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our latest projects where vision meets reality
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 group cursor-pointer">
            <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
              <img
                src={portfolioProjects[0].image}
                alt={portfolioProjects[0].title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="inline-block px-4 py-1 bg-teal-600 text-white text-sm rounded-full mb-3">
                  {portfolioProjects[0].category}
                </span>
                <h3 className="text-3xl font-bold text-white mb-2">{portfolioProjects[0].title}</h3>
                <p className="text-white/90 mb-4">{portfolioProjects[0].description}</p>
                <span className="text-teal-400 font-medium hover:text-teal-300 whitespace-nowrap">
                  View Project →
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1 flex flex-col gap-6">
            {portfolioProjects.slice(1, 3).map((project, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="relative h-[288px] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block px-3 py-1 bg-teal-600 text-white text-xs rounded-full mb-2">
                      {project.category}
                    </span>
                    <h3 className="text-xl font-bold text-white mb-1">{project.title}</h3>
                    <p className="text-sm text-white/90 mb-2">{project.description}</p>
                    <span className="text-teal-400 text-sm font-medium hover:text-teal-300 whitespace-nowrap">
                      View Project →
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {portfolioProjects.slice(3).map((project, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative h-[400px] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-teal-600 text-white text-xs rounded-full mb-2">
                    {project.category}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-1">{project.title}</h3>
                  <p className="text-sm text-white/90 mb-2">{project.description}</p>
                  <span className="text-teal-400 text-sm font-medium hover:text-teal-300 whitespace-nowrap">
                    View Project →
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}